import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import * as moment from 'moment';
import { CompanyService } from 'src/app/services/core/company/company.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { FundingSourceService } from 'src/app/services/core/funding-source/funding-source.service';
import { LosService } from 'src/app/services/core/levelOfService/los.service';
import { SpaceTypeService } from 'src/app/services/core/spaceTypes/space-type.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-calculate-fare-modal',
  templateUrl: './calculate-fare-modal.component.html',
  styleUrls: ['./calculate-fare-modal.component.css'],
})
export class CalculateFareModalComponent implements OnInit {
  @Input() fareData: any = {};


  @Output() close = new EventEmitter<void>();
  @Output() submit = new EventEmitter<any>();

  form!: FormGroup;
  submitted = false;
  spaceTypeList: any = [];
  levelOfServiceList: any = [];
  fundingSourceList: any[] = [];
  originalSpaceTypeList: any[] = [];
  companyList: any[] = [];
  fareDetails:any={}

  constructor(
    private fb: FormBuilder,
    private fundingSource: FundingSourceService,
    private credentialService: CredentialService,
    private tripService: TripService,
    private spaceTypeService: SpaceTypeService,
    private levelOfService: LosService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.loadFundingSources();
    this.loadTransportProviders();
    this.loadLevelOfService();
    this.loadSpaceTypes();
  }
  eitherFundingOrCompanyValidator(): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const funding = group.get('fundingsource')?.value;
    const company = group.get('company')?.value;

    
    if (!funding && !company) {
      return { eitherRequired: true };
    }
    return null;
  };
}
 initializeForm() {
    this.form = this.fb.group({
      fundingsource: [this.fareData?.fundingsource?.value || ''],
      levelOfService: [this.fareData?.levelOfService?.value || '',Validators.required],
      spaceType: [this.fareData?.spaceType?.value|| '',Validators.required],
      company: [this.fareData?.company || ''],
      pickup: this.fb.group({
        time: [{ value: moment(this.fareData?.pickup?.value?.time).format('MM/DD/YYYY HH:mm') || '', disabled: true }],
        address: this.fb.group({
          name: [
            {
              value: this.fareData?.pickup?.value?.address?.name || '',
              disabled: true,
            },
          ],
        }),
      }),
      destination: this.fb.group({
        time: [{ value: moment(this.fareData?.destination?.value?.time).format('MM/DD/YYYY HH:mm') || '', disabled: true }],
        address: this.fb.group({
          name: [
            {
              value: this?.fareData?.destination?.value?.address?.name || '',
              disabled: true,
            },
          ],
        }),
      }),
    },
    { validators: this.eitherFundingOrCompanyValidator() } 
  );
}
onSelectChange(value: any, controlName: string) {
  if (controlName === 'fundingsource') {
    
    this.form.get('fundingsource')?.setValue(value || '');
 
    this.form.get('company')?.setValue('');
  } else if (controlName === 'company') {

    this.form.get('company')?.setValue(value || '');
    this.form.get('fundingsource')?.setValue('');
  }
}

  onClose() {
    this.close.emit();
  }

  loadFundingSources() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.fundingSource.getPicker(queryParams).subscribe((res: any) => {
      this.fundingSourceList = res?.results || [];
    });
  }

  loadTransportProviders() {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.credentialService.getPicker(queryParams).subscribe((res: any) => {
      this.companyList = res?.results || [];
    });
  }

  loadLevelOfService(): void {
    this.levelOfService.getPicker({ isActive: true, limit: 9999 }).subscribe({
      next: (res: any) => {
        this.levelOfServiceList = res?.results || [];
      
      },
      error: (err) => {
        console.error("❌ Error loading LevelOfService:", err);
      },
    });
  }

  loadSpaceTypes(): void {
    const queryParams = {
      isActive: true,
      limit: 9999
    };
    this.spaceTypeService.getPicker(queryParams).subscribe({
      next: (res: any) => {
        this.originalSpaceTypeList = res?.results || [];
        this.spaceTypeList = [...this.originalSpaceTypeList]; // start with all
      },
      error: (err) => {
        console.error('❌ Error loading SpaceTypes:', err);
      }
    });
  }
  onSelectLOS(losId: any) {
    if (!losId) {
      this.spaceTypeList = [];
      this.form.patchValue({ spaceType: '' });
      return;
    }

  const filtered = this.originalSpaceTypeList.filter((item: any) => item.los === losId);
    this.spaceTypeList = filtered;

    if (!this.spaceTypeList.some((item: any) => item.id === this.form.value.spaceType)) {
      this.form.patchValue({ spaceType: '' });
    }
  }
  getSortedBreakdown(breakdown: any) {
    if (!breakdown) return [];

    const priority: Record<string, number> = {
      total: 0,
      baseFare: 1,
    };
      
    return Object.entries(breakdown)
  
      .sort(([keyA], [keyB]) => {
        const orderA = keyA in priority ? priority[keyA] : 2;
        const orderB = keyB in priority ? priority[keyB] : 2;
        return orderA - orderB;
      })
      .map(([key, value]) => ({
        key: this.formatKey(key),
      value
      }));
  }
  private formatKey(key: string): string {
    return key
    .replace(/([A-Z])/g, ' $1')           // insert space before capital letters
    .replace(/^./, char => char.toUpperCase()); // capitalize first letter
  }
  formatValue(value: any) {
  

    if (typeof value === 'number') {
      return value.toFixed(2);
    } else if (typeof value === 'object' && value !== null) {
    return `Rate: ${value.fare ?? 'N/A'} From: ${value.from ?? ''} To: ${value.to ?? ''}`;
    } else {
      return 'N/A';
    }
  }
  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    const fundingSourceValue = this.form.get('fundingsource')?.value;
    const companyValue = this.form.get('company')?.value;
    const trip = {
      pickup: {
        time: this.fareData?.pickup?.value?.time, // ISO format or string as required
        address: {
          coords: this.fareData?.pickup?.value?.address?.coords || [],
        },
      },
      destination: {
        address: {
          coords: this.fareData?.destination?.value?.address?.coords || [],
        },
      },
      levelOfService: this.form.get('levelOfService')?.value || null,
      spaceType: this.form.get('spaceType')?.value || null,
    };
    const payload: any = {
      trips: [trip],
      company: companyValue || null,
      fundingsource: fundingSourceValue || null,
    };
    Object.keys(payload).forEach((key) => {
      if (
        payload[key] === null ||
        payload[key] === undefined ||
        payload[key] === ""
      ) {
        delete payload[key];
      }
    });

    this.tripService.calculateFare(payload).subscribe({
      next: (response: any) => {
        
        this.fareDetails=response[0]?.breakdown || {}
       if (response.length === 0 ) {
          sweetAlert('No Rate', 'No fare calculated for the given details', 'info', 'Ok');
        }
        this.submit.emit(response); 
     
      },
      error: (err) => {
        
        sweetAlert('Error', 'Failed to calculate fare', 'error', 'Ok');
      },
    });
  }

  isNumberValue(value: any): boolean {
    return typeof value === 'number' && !isNaN(value);
  }
}

